import React, { useContext, useEffect, useState } from "react";
import MeterForms from "../FormsTariff/MeterForms";
import PackagesForms from "../FormsTariff/PackagesForms";
import PackagesRatesForms from "../FormsTariff/PackagesRatesForms";
import CorprateForms from "../FormsTariff/CorprateForms";
import CustomTabs from "../../CommonElements/CommonTabs/CustomTabs";
import ThirdPartyForm from "../FormsTariff/ThirdPartyForm";
import SharedDataContext from "../../_helper/SharedData";
import { getTaxGroupList } from "../../Services/Packages.service";

function ThirdPartyFlow({setTitle}) {
  const { cityData } = useContext(SharedDataContext);
  const [createdPackage, setCreatedPackage] = useState({});
  const [packId, setPackId] = useState();
  const [newFlow, setNewFlow] = useState(true);
  const [taxArr, setTaxArr] = useState([]);

  useEffect(() => {
    getTaxGroupList().then((result) => {
      if (result.status == 200) {
        const data = result.data.map((element) => {
          return {
            value: element,
            label: element.name,
          };
        });
        setTaxArr(generateTaxCombinationsForSelectBox(data));
      }
    });
  }, []);

  const tabs = [
    {
      label: "Packages",
      content: (
        <PackagesForms
          setCreatedPackage={setCreatedPackage}
          cityData={cityData}
          isThirdParty={true}
          setPackId={setPackId}
          newFlow={newFlow}
          setNewFlow={setNewFlow}
          taxArr={taxArr}
          setTitle={setTitle}
        />
      ),
    },
    {
      label: "Packages Rates",
      content: (
        <PackagesRatesForms createdPackage={createdPackage} packId={packId} setTitle={setTitle}/>
      ),
    },
  ];

  function generateTaxCombinationsForSelectBox(taxData) {
    const combinations = [];

    taxData.forEach((baseTax) => {
      taxData.forEach((serviceTax) => {
        const label = `Base ${
          baseTax.value.taxPercentage === "12%" ? "6%" : "0%"
        } Service ${serviceTax.value.taxPercentage === "12%" ? "6%" : "0%"}`;
        const value = {
          baseTax: baseTax.value,
          serviceTax: serviceTax.value,
        };
        combinations.push({ label, value });
      });
    });

    return combinations;
  }

  return <CustomTabs tabs={tabs} />;
}

export default ThirdPartyFlow;
